import type { ActionConfig } from './types';

export const officeNoteActions: ActionConfig[] = [
  // =============================================================================
  // RECORD ACTIONS
  // =============================================================================
  {
    id: 'onote-edit',
    name: 'Edit',
    icon: 'edit',
    table: 'officeNotes',
    type: 'EDIT_RECORD',
    prominence: 'prominent',
    order: 1,
    config: {},
  },
  {
    id: 'onote-add',
    name: 'Add',
    icon: 'plus',
    table: 'officeNotes',
    type: 'ADD_RECORD',
    prominence: 'prominent',
    order: 2,
    config: {},
  },
  {
    id: 'onote-delete',
    name: 'Delete',
    icon: 'trash',
    table: 'officeNotes',
    type: 'DELETE_RECORD',
    prominence: 'menu',
    order: 99,
    needsConfirmation: true,
    confirmationMessage: 'Are you sure you want to delete this office note?',
    config: {},
  },

  // =============================================================================
  // NAVIGATION ACTIONS
  // =============================================================================
  {
    id: 'onote-view-client',
    name: 'View Client',
    icon: 'chevron-circle-right',
    table: 'officeNotes',
    type: 'NAVIGATE_APP',
    prominence: 'inline',
    order: 10,
    config: {
      route: '/clients/:clientId',
      params: { clientId: 'clientId' },
    },
  },

  // =============================================================================
  // SET COLUMN VALUE ACTIONS
  // =============================================================================
  {
    id: 'onote-mark-resolved',
    name: 'Mark Resolved',
    icon: 'check-circle',
    table: 'officeNotes',
    type: 'SET_COLUMN_VALUE',
    prominence: 'prominent',
    order: 20,
    condition: (row) => !row.resolved,
    config: {
      column: 'resolved',
      value: true,
    },
  },
  {
    id: 'onote-mark-important',
    name: 'Mark Important',
    icon: 'star',
    table: 'officeNotes',
    type: 'SET_COLUMN_VALUE',
    prominence: 'menu',
    order: 21,
    config: {
      column: 'important',
      value: true,
    },
  },
];
